import React from 'react'
import { Button, Flex, Tag, Card, Typography } from 'antd'
import { DeleteOutlined, MenuOutlined } from '@ant-design/icons'
import { Draggable } from 'react-beautiful-dnd'
import { useAssignmentAccess } from '../../../../components/access/Access'
import { useThemeColors } from '../../../../../../hooks/useThemeColors'
import { TextContentRules } from '../../../../components/access/access-rules/assignment-rules'

const { Text } = Typography

const ToolCard = ({ tool, index, boosterDetails, onRemove, isRemoving }) => {
    const colors = useThemeColors()
    const { hasAccess: hasEditPermission } = useAssignmentAccess(TextContentRules.EDIT_GRADINGS)

    if (!boosterDetails) return null

    return (
        <Draggable 
            key={tool.senseBoosterId} 
            draggableId={String(tool.senseBoosterId)} 
            index={index}
            isDragDisabled={!hasEditPermission}
        >
            {(provided, snapshot) => (
                <Card
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    style={{
                        marginBottom: 8,
                        backgroundColor: snapshot.isDragging ? colors.hoverBg : undefined,
                        border: snapshot.isDragging ? `2px dashed ${colors.primary}` : undefined,
                        ...provided.draggableProps.style,
                    }}
                    size='small'
                >
                    <Flex justify='space-between' align='center'>
                        <Flex gap={8} align='center' style={{ flex: 1 }}>
                            {hasEditPermission && (
                                <div
                                    {...provided.dragHandleProps}
                                    style={{ 
                                        cursor: 'grab',
                                        color: colors.secondaryText,
                                        display: 'flex',
                                        alignItems: 'center'
                                    }}
                                >
                                    <MenuOutlined />
                                </div>
                            )}
                            <Flex vertical gap={2} style={{ flex: 1 }}>
                                <Flex gap={8} align='center'>
                                    <Text strong>{boosterDetails.displayName}</Text>
                                    {boosterDetails.isInternal && (
                                        <Tag size='small' color='blue' bordered={false}>Internal</Tag>
                                    )}
                                </Flex>
                                <Text type='secondary' style={{ fontSize: '12px' }}>
                                    {boosterDetails.description}
                                </Text>
                            </Flex>
                        </Flex>
                        
                        {hasEditPermission && (
                            <Button
                                type='text'
                                danger
                                size='small'
                                aria-label='Remove tool'
                                title='Remove Tool'
                                onClick={() => onRemove(tool.senseBoosterId)}
                                loading={isRemoving}
                            >
                                <DeleteOutlined />
                            </Button>
                        )}
                    </Flex>
                </Card>
            )}
        </Draggable>
    )
}

export default ToolCard